import { useIntl } from 'react-intl';
import { PropsWithChildren } from 'react';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';

type OptionalLabelProps = PropsWithChildren<{
    isOptional: boolean;
    htmlFor: string | undefined;
}>;

export const OptionalLabel = ({ isOptional, htmlFor, children }: OptionalLabelProps) => {
    const intl = useIntl();
    const optionalMessage = intl.formatMessage({
        id: 'outboundPortal.serviceOrder.sidebar.generalInformation.optional',
    });

    return (
        <FormLabel
            htmlFor={htmlFor}
            supportingText={isOptional ? optionalMessage : undefined}
            className="ellipsis-1 margin-bottom-0"
        >
            {children}
        </FormLabel>
    );
};
